import { render } from "./RecoverPasswordPage.vue?vue&type=template&id=6e79da2a"
import script from "./RecoverPasswordPage.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordPage.vue?vue&type=script&lang=js"

import "./RecoverPasswordPage.vue?vue&type=style&index=0&id=6e79da2a&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__